import { useEffect, useRef } from 'react';

export function useWindowEvent<T extends keyof WindowEventMap>(
  eventType: T,
  callback: (event: WindowEventMap[T]) => void,
  passive = true
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const listener = (event: WindowEventMap[T]) => callbackRef.current(event);

    window.addEventListener(eventType, listener, { passive });

    return () => {
      window.removeEventListener(eventType, listener);
    };
  }, [eventType, passive]);
}
